module.exports = __webpack_public_path__ + "media/images/vendor_intro_slide_img_03-482ba33beadb414713854691a873fb00.jpg";